import { useEffect } from "react";
import { useCustomerSimple } from "@commercekit/remix";

const COOKIE_NAME = "user_email";
const COOKIE_MAX_AGE = 60 * 60 * 24 * 30; // 30 days

// Raw email (no encodeURIComponent): @ is safe in cookies per RFC 6265, and
// TAGGRS reads the cookie value as-is in server-side GTM — encoding produces %40.
export function setUserEmailCookie(email: string) {
  if (typeof document === "undefined" || !email) return;
  document.cookie = `${COOKIE_NAME}=${email};path=/;max-age=${COOKIE_MAX_AGE};SameSite=Lax;Secure`;
}

export function getUserEmailCookie(): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]*)`)
  );
  return match ? decodeURIComponent(match[1]) : null;
}

/**
 * Sets the user_email first-party cookie whenever a logged-in customer is detected.
 * Should be called once at the layout level.
 */
export const useUserEmailCookieSync = () => {
  const { customer } = useCustomerSimple();
  useEffect(() => {
    if (customer?.email) {
      setUserEmailCookie(customer.email);
    }
  }, [customer?.email]);
};
